import { cn } from 'lib/cn';
import { Card, Badge } from 'components/ui';
import { StoreIcon } from 'components/icons';

/** Cards for every shop the user owns; the active shop is highlighted. */
export function ShopList({ shops, activeShopId }) {
  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {shops.map((shop) => {
        const profile = shop.profile || {};
        const isActive = profile.id && profile.id === activeShopId;
        const image = profile.logoUrl || profile.businessImageUrl;
        const location = [profile.city, profile.state].filter(Boolean).join(', ');

        return (
          <Card
            key={profile.id}
            className={cn(isActive && 'border-brand-300 ring-1 ring-brand-200')}
          >
            <div className="flex items-start gap-3">
              <span className="h-10 w-10 shrink-0 overflow-hidden rounded-lg bg-surface-100">
                {image ? (
                  <img src={image} alt="" className="h-full w-full object-cover" loading="lazy" />
                ) : (
                  <span className="flex h-full items-center justify-center text-slate-300">
                    <StoreIcon className="h-5 w-5" />
                  </span>
                )}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-slate-900">
                  {profile.displayName || profile.businessName || 'Shop'}
                </p>
                {location && <p className="truncate text-xs text-slate-500">{location}</p>}
                <div className="mt-2 flex flex-wrap gap-1.5">
                  {isActive && <Badge tone="brand">Active</Badge>}
                  <Badge tone={profile.isOnline ? 'success' : 'neutral'}>
                    {profile.isOnline ? 'Online' : 'Offline'}
                  </Badge>
                  {profile.isVerified && <Badge tone="success">Verified</Badge>}
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
}

export default ShopList;
